var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18.3559C27.0343 18.3559 28.4065 19.2346 29.1889 19.9688L32.2463 16.9837C30.3686 15.2383 27.925 14.167 25 14.167C20.763 14.167 17.1037 16.5985 15.3223 20.1374L18.825 22.8577C19.7037 20.2457 22.1352 18.3559 25 18.3559Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4 25.2412C35.4 24.3504 35.3278 23.7004 35.1713 23.0264H25V27.0467H30.9704C30.85 28.0458 30.2 29.5504 28.7556 30.5616L32.1741 33.2097C34.2204 31.3199 35.4 28.5393 35.4 25.2412Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8369 27.1433C18.6082 26.4692 18.4758 25.747 18.4758 25.0007C18.4758 24.2544 18.6082 23.5321 18.8248 22.8581L15.3221 20.1377C14.5878 21.6062 14.1665 23.2553 14.1665 25.0007C14.1665 26.746 14.5878 28.3951 15.3221 29.8636L18.8369 27.1433Z",
    fill: "#FBBC05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9997 35.8333C27.9247 35.8333 30.3803 34.8704 32.1738 33.2092L28.7553 30.5611C27.8405 31.1991 26.6127 31.6444 24.9997 31.6444C22.1349 31.6444 19.7034 29.7546 18.8368 27.1426L15.334 29.8629C17.1155 33.4018 20.7627 35.8333 24.9997 35.8333Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogin);
export default __webpack_public_path__ + "static/media/google-login.36d50c89445607ec622a68b42cc5e022.svg";
export { ForwardRef as ReactComponent };